<div class="header">
  <div class="header__outer-layout-container">
    <app-logo class="header__outer-container header__outer-container--logo"></app-logo>

    <div class="header__inner-layout-container">
      <app-navigation class="header__middle-container" *ngIf="isLoggedIn"></app-navigation>
    </div>

    <app-user class="header__outer-container header__outer-container--user"></app-user>
  </div>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/header/header.component.html